import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';
import { MOCK_AGGREGATE } from './mockAggregate';
import type { GlobalAggregate } from './types';

type State =
  | { status: 'loading' }
  | { status: 'ready'; data: GlobalAggregate; demo: boolean }
  | { status: 'error'; error: Error };

export function useAggregates(): State {
  const [state, setState] = useState<State>({ status: 'loading' });

  useEffect(() => {
    const ref = doc(db, 'aggregates', 'global');
    const unsub = onSnapshot(
      ref,
      snap => {
        if (!snap.exists()) {
          // Real aggregate isn't populated yet (cron is disabled pre-launch).
          // Fall back to deterministic mock data so the stats page has life.
          setState({ status: 'ready', data: MOCK_AGGREGATE, demo: true });
          return;
        }
        setState({ status: 'ready', data: snap.data() as GlobalAggregate, demo: false });
      },
      err => setState({ status: 'error', error: err as Error }),
    );
    return unsub;
  }, []);

  return state;
}
